import MultiplicationTablesWithinRange from '../static_json/multiplicationTablesWithinRanges';
const GeneratesQuestion = {

    install(Vue, options) {

        /**
         * Returns a question and answer for a gameType based on the numberGenerator.
         *
         * @param gameType
         * @param numberGenerator
         * @returns {*}
         */
        Vue.$generateQuestion = (gameType, numberGenerator) => {

            switch (gameType) {
                case 'TYPE_MULTIPLICATION':
                    return Vue.generateMultiplyQuestion(numberGenerator);
                case 'TYPE_SUBTRACTION':
                    return Vue.generateSubtractionQuestion(numberGenerator);
                case 'TYPE_DIVIDING':
                    return Vue.generateDivisionQuestion(numberGenerator);
                case 'TYPE_ADDITION':
                default:
                    return Vue.generateAdditionQuestion(numberGenerator);
            }
        };

        /**
         * Returns a random integer between min (inclusive) and max (inclusive).
         */
        Vue.getRandomNumber = (min, max) => {
            return Math.floor(Math.random() * (max - min + 1)) + min;
        };

        /**
         * Addition.
         *
         * @param numberGenerator
         * @returns {{number1: (*|number), number2: (*|number), answer: number}}
         */
        Vue.generateAdditionQuestion = (numberGenerator) => {

            let number1 = 0;
            let number2 = 0;

            switch(numberGenerator.type) {
                case 'custom':
                    number1 = Vue.getRandomNumber(parseInt(numberGenerator.nr1Min), parseInt(numberGenerator.nr1Max));
                    number2 = Vue.getRandomNumber(parseInt(numberGenerator.nr2Min), parseInt(numberGenerator.nr2Max));
                    break;
                case 'scale':
                default:
                    number1 = Vue.getRandomNumber(numberGenerator.nr1r, numberGenerator.nr2r);number1 = Vue.getRandomNumber(numberGenerator.nr1r, numberGenerator.nr2r);

                    if (numberGenerator.hasOwnProperty('nr3r')) {
                        number2 = Vue.getRandomNumber(numberGenerator.nr3r, numberGenerator.nr2 - number1)
                    }
                    else {
                        number2 = Vue.getRandomNumber(numberGenerator.nr1, numberGenerator.nr2 - number1);
                    }

                    break;
            }

            const answer = number1 + number2;

            return {
                number1: number1,
                number2: number2,
                answer: answer
            };
        };

        /**
         * Subtraction.
         *
         * @param numberGenerator
         * @returns {{number1: (*|number), number2: (*|number), answer: number}}
         */
        Vue.generateSubtractionQuestion = (numberGenerator) => {

            let number1 = 0;
            let number2 = 0;

            switch(numberGenerator.type) {
                case 'custom':
                    number1 = Vue.getRandomNumber(parseInt(numberGenerator.nr1Min), parseInt(numberGenerator.nr1Max));
                    number2 = Vue.getRandomNumber(parseInt(numberGenerator.nr2Min), parseInt(numberGenerator.nr2Max));
                    break;
                case 'scale':
                default:
                    number1 = Vue.getRandomNumber(numberGenerator.nr1r, numberGenerator.nr2);
                    number2 = Vue.getRandomNumber(numberGenerator.nr2r, number1 - numberGenerator.nr3r);

                    break;
            }

            const answer = number1 - number2;

            return {
                number1: number1,
                number2: number2,
                answer: answer
            };
        };

        /**
         * Multiply.
         *
         * @param numberGenerator
         * @returns {{number1: (*|number), number2: (*|number), answer: number}}
         */
        Vue.generateMultiplyQuestion = (numberGenerator) => {

            let number1 = 0;
            let number2 = 0;

            switch(numberGenerator.type) {
                case 'fixedNumber':
                    number1 = parseInt(numberGenerator.number);
                    number2 = Vue.getRandomNumber(1, 10);
                    break;
                case 'custom':
                    number1 = Vue.getRandomNumber(parseInt(numberGenerator.nr1Min), parseInt(numberGenerator.nr1Max));
                    number2 = Vue.getRandomNumber(parseInt(numberGenerator.nr2Min), parseInt(numberGenerator.nr2Max));
                    break;
                case 'scale':
                default:
                    number1 = Vue.getRandomNumber(numberGenerator.nr1, numberGenerator.nr2);
                    number2 = Vue.getRandomNumber(1, 10);

                    break;
            }

            const answer = number1 * number2;

            return {
                number1: number1,
                number2: number2,
                answer: answer
            };
        };

        /**
         * Divide.
         *
         * @param numberGenerator
         * @returns {{number1: (*|number), number2: (*|number), answer: number}}
         */
        Vue.generateDivisionQuestion = (numberGenerator) => {

            let number1 = 0;
            let number2 = 0;
            let answer = 0;

            let divisorType = typeof numberGenerator.divisor === 'object' ? 'inRangeDivisor' : 'fixedDivisor';

            let number1Multipliers = 0;
            let countOfNumber1Multipliers = 0;
            const maxDividend = localStorage.getItem('locale') === 'en' ? 12 : 10;

            switch(divisorType) {
                case 'fixedDivisor':

                    if (numberGenerator.divisor > numberGenerator.dividend) {
                        numberGenerator.divisor = numberGenerator.dividend;
                    }

                    number1 = numberGenerator.divisor;

                    number1Multipliers = MultiplicationTablesWithinRange[numberGenerator.dividend][number1].filter(dividend => dividend <= maxDividend);
                    countOfNumber1Multipliers = number1Multipliers.length;

                    number2 = number1Multipliers[Vue.getRandomNumber(0, countOfNumber1Multipliers-1)];

                    answer = number1 * number2;
                    return {
                        number1: answer,
                        number2: number1,
                        answer: number2
                    };
                case 'inRangeDivisor':

                    if (numberGenerator.divisor.nr2 > numberGenerator.dividend) {
                        numberGenerator.divisor.nr2 = numberGenerator.dividend;
                    }

                    number1 = Vue.getRandomNumber(numberGenerator.divisor.nr1, numberGenerator.divisor.nr2);

                    number1Multipliers = MultiplicationTablesWithinRange[numberGenerator.dividend][number1].filter(dividend => dividend <= maxDividend);
                    countOfNumber1Multipliers = number1Multipliers.length;

                    number2 = number1Multipliers[Vue.getRandomNumber(0, countOfNumber1Multipliers-1)];

                    answer = number1 * number2;
                    return {
                        number1: answer,
                        number2: number1,
                        answer: number2
                    };
            }
        };

    },

};

export default GeneratesQuestion
